import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import InputField from 'components/LoginForm/Input';
import { HashLink as Link } from 'react-router-hash-link';

const RegisterTrade = props => (
  <div className="Register">
    <p htmlFor="reg_agency_business" />
    <br />
    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="email"
      fieldName="reg_email"
      fieldPlaceholder="Email *"
      icon="at"
    />

    <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_password"
      fieldPlaceholder={i18n.translate('loginScreen.fields.password')}
      icon="key"
      line
    />

    <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_passwordConfirm"
      fieldPlaceholder={i18n.translate('loginScreen.fields.passwordConfirm')}
      icon="key"
      line
    />

    <div className="step">Step 2: Complete your profile.</div>
    <h5 style={{ marginTop: '2rem' }}>
      <b>Tell Us About Yourself</b>
    </h5>
    <hr className="short" />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_custom_1"
      fieldPlaceholder={i18n.translate('loginScreen.fields.salutation')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_first_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.firstName')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_last_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.lastName')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_title"
      fieldPlaceholder="Business Title *"
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_agency_name"
      fieldPlaceholder="Agency Name *"
      icon="home"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_host_agency_name"
      fieldPlaceholder="Host Agency Name"
      icon="home"
      required={false}
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_city"
      fieldPlaceholder={i18n.translate('loginScreen.fields.city')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_state"
      fieldPlaceholder={i18n.translate('loginScreen.fields.stateProvince')}
      icon="map"
    />

    <p htmlFor="reg_country" className="reg_country">Country / Region</p>
    <select id="reg_country" name="reg_country" onChange={props.change}>
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="AF">Afghanistan</option>
      <option value="AX">Åland Islands</option>
      <option value="AL">Albania</option>
      <option value="DZ">Algeria</option>
      <option value="AS">American Samoa</option>
      <option value="AD">Andorra</option>
      <option value="AO">Angola</option>
      <option value="AI">Anguilla</option>
      <option value="AQ">Antarctica</option>
      <option value="AG">Antigua and Barbuda</option>
      <option value="AR">Argentina</option>
      <option value="AM">Armenia</option>
      <option value="AW">Aruba</option>
      <option value="AU">Australia</option>
      <option value="AT">Austria</option>
      <option value="AZ">Azerbaijan</option>
      <option value="BS">Bahamas</option>
      <option value="BH">Bahrain</option>
      <option value="BD">Bangladesh</option>
      <option value="BB">Barbados</option>
      <option value="BY">Belarus</option>
      <option value="BE">Belgium</option>
      <option value="BZ">Belize</option>
      <option value="BJ">Benin</option>
      <option value="BM">Bermuda</option>
      <option value="BT">Bhutan</option>
      <option value="BO">Bolivia, Plurinational State of</option>
      <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
      <option value="BA">Bosnia and Herzegovina</option>
      <option value="BW">Botswana</option>
      <option value="BV">Bouvet Island</option>
      <option value="BR">Brazil</option>
      <option value="IO">British Indian Ocean Territory</option>
      <option value="BN">Brunei Darussalam</option>
      <option value="BG">Bulgaria</option>
      <option value="BF">Burkina Faso</option>
      <option value="BI">Burundi</option>
      <option value="KH">Cambodia</option>
      <option value="CM">Cameroon</option>
      <option value="CA">Canada</option>
      <option value="CV">Cape Verde</option>
      <option value="KY">Cayman Islands</option>
      <option value="CF">Central African Republic</option>
      <option value="TD">Chad</option>
      <option value="CL">Chile</option>
      <option value="CN">China</option>
      <option value="CX">Christmas Island</option>
      <option value="CC">Cocos (Keeling) Islands</option>
      <option value="CO">Colombia</option>
      <option value="KM">Comoros</option>
      <option value="CG">Congo</option>
      <option value="CD">Congo, the Democratic Republic of the</option>
      <option value="CK">Cook Islands</option>
      <option value="CR">Costa Rica</option>
      <option value="CI">Côte d'Ivoire</option>
      <option value="HR">Croatia</option>
      <option value="CU">Cuba</option>
      <option value="CW">Curaçao</option>
      <option value="CY">Cyprus</option>
      <option value="CZ">Czech Republic</option>
      <option value="DK">Denmark</option>
      <option value="DJ">Djibouti</option>
      <option value="DM">Dominica</option>
      <option value="DO">Dominican Republic</option>
      <option value="EC">Ecuador</option>
      <option value="EG">Egypt</option>
      <option value="SV">El Salvador</option>
      <option value="GQ">Equatorial Guinea</option>
      <option value="ER">Eritrea</option>
      <option value="EE">Estonia</option>
      <option value="ET">Ethiopia</option>
      <option value="FK">Falkland Islands (Malvinas)</option>
      <option value="FO">Faroe Islands</option>
      <option value="FJ">Fiji</option>
      <option value="FI">Finland</option>
      <option value="FR">France</option>
      <option value="GF">French Guiana</option>
      <option value="PF">French Polynesia</option>
      <option value="TF">French Southern Territories</option>
      <option value="GA">Gabon</option>
      <option value="GM">Gambia</option>
      <option value="GE">Georgia</option>
      <option value="DE">Germany</option>
      <option value="GH">Ghana</option>
      <option value="GI">Gibraltar</option>
      <option value="GR">Greece</option>
      <option value="GL">Greenland</option>
      <option value="GD">Grenada</option>
      <option value="GP">Guadeloupe</option>
      <option value="GU">Guam</option>
      <option value="GT">Guatemala</option>
      <option value="GG">Guernsey</option>
      <option value="GN">Guinea</option>
      <option value="GW">Guinea-Bissau</option>
      <option value="GY">Guyana</option>
      <option value="HT">Haiti</option>
      <option value="HM">Heard Island and McDonald Islands</option>
      <option value="VA">Holy See (Vatican City State)</option>
      <option value="HN">Honduras</option>
      <option value="HK">Hong Kong SAR, China</option>
      <option value="HU">Hungary</option>
      <option value="IS">Iceland</option>
      <option value="IN">India</option>
      <option value="ID">Indonesia</option>
      <option value="IR">Iran, Islamic Republic of</option>
      <option value="IQ">Iraq</option>
      <option value="IE">Ireland</option>
      <option value="IM">Isle of Man</option>
      <option value="IL">Israel</option>
      <option value="IT">Italy</option>
      <option value="JM">Jamaica</option>
      <option value="JP">Japan</option>
      <option value="JE">Jersey</option>
      <option value="JO">Jordan</option>
      <option value="KZ">Kazakhstan</option>
      <option value="KE">Kenya</option>
      <option value="KI">Kiribati</option>
      <option value="KP">Korea, Democratic People's Republic of</option>
      <option value="KR">Korea, Republic of</option>
      <option value="KW">Kuwait</option>
      <option value="KG">Kyrgyzstan</option>
      <option value="LA">Lao People's Democratic Republic</option>
      <option value="LV">Latvia</option>
      <option value="LB">Lebanon</option>
      <option value="LS">Lesotho</option>
      <option value="LR">Liberia</option>
      <option value="LY">Libya</option>
      <option value="LI">Liechtenstein</option>
      <option value="LT">Lithuania</option>
      <option value="LU">Luxembourg</option>
      <option value="MO">Macao SAR, China</option>
      <option value="MK">Macedonia, the former Yugoslav Republic of</option>
      <option value="MG">Madagascar</option>
      <option value="MW">Malawi</option>
      <option value="MY">Malaysia</option>
      <option value="MV">Maldives</option>
      <option value="ML">Mali</option>
      <option value="MT">Malta</option>
      <option value="MH">Marshall Islands</option>
      <option value="MQ">Martinique</option>
      <option value="MR">Mauritania</option>
      <option value="MU">Mauritius</option>
      <option value="YT">Mayotte</option>
      <option value="MX">Mexico</option>
      <option value="FM">Micronesia, Federated States of</option>
      <option value="MD">Moldova, Republic of</option>
      <option value="MC">Monaco</option>
      <option value="MN">Mongolia</option>
      <option value="ME">Montenegro</option>
      <option value="MS">Montserrat</option>
      <option value="MA">Morocco</option>
      <option value="MZ">Mozambique</option>
      <option value="MM">Myanmar</option>
      <option value="NA">Namibia</option>
      <option value="NR">Nauru</option>
      <option value="NP">Nepal</option>
      <option value="NL">Netherlands</option>
      <option value="NC">New Caledonia</option>
      <option value="NZ">New Zealand</option>
      <option value="NI">Nicaragua</option>
      <option value="NE">Niger</option>
      <option value="NG">Nigeria</option>
      <option value="NU">Niue</option>
      <option value="NF">Norfolk Island</option>
      <option value="MP">Northern Mariana Islands</option>
      <option value="NO">Norway</option>
      <option value="OM">Oman</option>
      <option value="PK">Pakistan</option>
      <option value="PW">Palau</option>
      <option value="PS">Palestinian Territory, Occupied</option>
      <option value="PA">Panama</option>
      <option value="PG">Papua New Guinea</option>
      <option value="PY">Paraguay</option>
      <option value="PE">Peru</option>
      <option value="PH">Philippines</option>
      <option value="PN">Pitcairn</option>
      <option value="PL">Poland</option>
      <option value="PT">Portugal</option>
      <option value="PR">Puerto Rico</option>
      <option value="QA">Qatar</option>
      <option value="RE">Réunion</option>
      <option value="RO">Romania</option>
      <option value="RU">Russian Federation</option>
      <option value="RW">Rwanda</option>
      <option value="BL">Saint Barthélemy</option>
      <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
      <option value="KN">Saint Kitts and Nevis</option>
      <option value="LC">Saint Lucia</option>
      <option value="MF">Saint Martin (French part)</option>
      <option value="PM">Saint Pierre and Miquelon</option>
      <option value="VC">Saint Vincent and the Grenadines</option>
      <option value="WS">Samoa</option>
      <option value="SM">San Marino</option>
      <option value="ST">Sao Tome and Principe</option>
      <option value="SA">Saudi Arabia</option>
      <option value="SN">Senegal</option>
      <option value="RS">Serbia</option>
      <option value="SC">Seychelles</option>
      <option value="SL">Sierra Leone</option>
      <option value="SG">Singapore</option>
      <option value="SX">Sint Maarten (Dutch part)</option>
      <option value="SK">Slovakia</option>
      <option value="SI">Slovenia</option>
      <option value="SB">Solomon Islands</option>
      <option value="SO">Somalia</option>
      <option value="ZA">South Africa</option>
      <option value="GS">South Georgia and the South Sandwich Islands</option>
      <option value="SS">South Sudan</option>
      <option value="ES">Spain</option>
      <option value="LK">Sri Lanka</option>
      <option value="SD">Sudan</option>
      <option value="SR">Suriname</option>
      <option value="SJ">Svalbard and Jan Mayen</option>
      <option value="SZ">Swaziland</option>
      <option value="SE">Sweden</option>
      <option value="CH">Switzerland</option>
      <option value="SY">Syrian Arab Republic</option>
      <option value="TW">Taiwan, Province of China</option>
      <option value="TJ">Tajikistan</option>
      <option value="TZ">Tanzania, United Republic of</option>
      <option value="TH">Thailand</option>
      <option value="TL">Timor-Leste</option>
      <option value="TG">Togo</option>
      <option value="TK">Tokelau</option>
      <option value="TO">Tonga</option>
      <option value="TT">Trinidad and Tobago</option>
      <option value="TN">Tunisia</option>
      <option value="TR">Turkey</option>
      <option value="TM">Turkmenistan</option>
      <option value="TC">Turks and Caicos Islands</option>
      <option value="TV">Tuvalu</option>
      <option value="UG">Uganda</option>
      <option value="UA">Ukraine</option>
      <option value="AE">United Arab Emirates</option>
      <option value="GB">United Kingdom</option>
      <option value="US">United States</option>
      <option value="UM">United States Minor Outlying Islands</option>
      <option value="UY">Uruguay</option>
      <option value="UZ">Uzbekistan</option>
      <option value="VU">Vanuatu</option>
      <option value="VE">Venezuela, Bolivarian Republic of</option>
      <option value="VN">Viet Nam</option>
      <option value="VG">Virgin Islands, British</option>
      <option value="VI">Virgin Islands, U.S.</option>
      <option value="WF">Wallis and Futuna</option>
      <option value="EH">Western Sahara</option>
      <option value="YE">Yemen</option>
      <option value="ZM">Zambia</option>
      <option value="ZW">Zimbabwe</option>
    </select>

    <h5 style={{ marginTop: '5rem' }}>
      <b>Describe Your Business</b>
    </h5>
    <hr className="short" />

    <p className="spacer">Which segment(s) do you primarily sell?</p>

    <div className="segments">
      <span className="checkItem">
        <InputField
          change={props.change}
          fieldLabel="Leisure"
          fieldName="reg_segment_leisure"
          fieldType="checkbox"
          userSelect={false}
          line={false}
          title="Leisure"
        />
      </span>
      <span className="checkItem">
        <InputField
          change={props.change}
          fieldLabel="Corporate"
          fieldName="reg_segment_corporate"
          fieldType="checkbox"
          userSelect={false}
          line={false}
          title="Corporate"
        />
      </span>
      <span className="checkItem">
        <InputField
          change={props.change}
          fieldLabel="Group"
          fieldName="reg_segment_group"
          fieldType="checkbox"
          userSelect={false}
          line={false}
          title="Group"
        />
      </span>
    </div>

    <p htmlFor="reg_agency_affiliation">What is Your Main Affiliation?</p>
    <select
      id="reg_agency_affiliation"
      name="reg_agency_affiliation"
      onChange={props.change}
    >
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="American Express">American Express</option>
      <option value="Ensemble Travel Network">Ensemble Travel Network</option>
      <option value="Signature Travel Network">Signature Travel Network</option>
      <option value="Internova">Internova</option>
      <option value="Traveller Made">Traveller Made</option>
      <option value="Virtuoso">Virtuoso</option>
      <option value="Other">Other</option>
      <option value="None">None</option>
    </select>

    <h5 style={{ marginTop: '5rem' }}>
      <b>What type of travel do you sell?</b>
    </h5>
    <hr className="short" />

    <p htmlFor="reg_travel_type_1">What is the #1 type of travel you sell?</p>
    <select
      id="reg_travel_type_1"
      name="reg_travel_type_1"
      onChange={props.change}
    >
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="Adventure Travel">Adventure Travel</option>
      <option value="Babymoon">Babymoon</option>
      <option value="Bachelor / Bachelorette Parties">
        Bachelor / Bachelorette Parties
      </option>
      <option value="Beach Destinations">Beach Destinations</option>
      <option value="Private Accommodations (Villas)">
        Private Accommodations (Villas)
      </option>
      <option value="Culinary (Food&Wine)">Culinary (Food&Wine)</option>
      <option value="Culture/Arts">Culture/Arts</option>
      <option value="Entertainment">Entertainment</option>
      <option value="Family Travel">Family Travel</option>
      <option value="Honeymoon">Honeymoon</option>
      <option value="Incentives/Meetings">Incentives/Meetings</option>
      <option value="ILGBTQ+">LGBTQ+</option>
      <option value="Multi-Gen Travel">Multi-Gen Travel</option>
      <option value="Religious Tourism">Religious Tourism</option>
      <option value="Safari">Safari</option>
      <option value="Spa/Wellness/Fitness">Spa/Wellness/Fitness</option>
      <option value="None of the Above">None of the Above</option>
    </select>

    <p htmlFor="reg_travel_type_2">What is the #2 type of travel you sell?</p>
    <select
      id="reg_travel_type_2"
      name="reg_travel_type_2"
      onChange={props.change}
    >
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="Adventure Travel">Adventure Travel</option>
      <option value="Babymoon">Babymoon</option>
      <option value="Bachelor / Bachelorette Parties">
        Bachelor / Bachelorette Parties
      </option>
      <option value="Beach Destinations">Beach Destinations</option>
      <option value="Private Accommodations (Villas)">
        Private Accommodations (Villas)
      </option>
      <option value="Culinary (Food&Wine)">Culinary (Food&Wine)</option>
      <option value="Culture/Arts">Culture/Arts</option>
      <option value="Entertainment">Entertainment</option>
      <option value="Family Travel">Family Travel</option>
      <option value="Honeymoon">Honeymoon</option>
      <option value="Incentives/Meetings">Incentives/Meetings</option>
      <option value="ILGBTQ+">LGBTQ+</option>
      <option value="Multi-Gen Travel">Multi-Gen Travel</option>
      <option value="Religious Tourism">Religious Tourism</option>
      <option value="Safari">Safari</option>
      <option value="Spa/Wellness/Fitness">Spa/Wellness/Fitness</option>
      <option value="None of the Above">None of the Above</option>
    </select>

    <p htmlFor="reg_travel_type_3">What is the #3 type of travel you sell?</p>
    <select
      id="reg_travel_type_3"
      name="reg_travel_type_3"
      onChange={props.change}
    >
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="Adventure/Soft Adventure/Expedition">
        Adventure/Soft Adventure/Expedition
      </option>
      <option value="Adventure Travel">Adventure Travel</option>
      <option value="Babymoon">Babymoon</option>
      <option value="Bachelor / Bachelorette Parties">
        Bachelor / Bachelorette Parties
      </option>
      <option value="Beach Destinations">Beach Destinations</option>
      <option value="Private Accommodations (Villas)">
        Private Accommodations (Villas)
      </option>
      <option value="Culinary (Food&Wine)">Culinary (Food&Wine)</option>
      <option value="Culture/Arts">Culture/Arts</option>
      <option value="Entertainment">Entertainment</option>
      <option value="Family Travel">Family Travel</option>
      <option value="Honeymoon">Honeymoon</option>
      <option value="Incentives/Meetings">Incentives/Meetings</option>
      <option value="ILGBTQ+">LGBTQ+</option>
      <option value="Multi-Gen Travel">Multi-Gen Travel</option>
      <option value="Religious Tourism">Religious Tourism</option>
      <option value="Safari">Safari</option>
      <option value="Spa/Wellness/Fitness">Spa/Wellness/Fitness</option>
      <option value="None of the Above">None of the Above</option>
    </select>

    <p htmlFor="reg_destination_1">
      What Destination/Region Do You Primarily Sell?
    </p>
    <select
      id="reg_destination_1"
      name="reg_destination_1"
      onChange={props.change}
    >
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="USA/Canada">USA/Canada</option>
      <option value="Mexico">Mexico</option>
      <option value="Caribbean">Caribbean</option>
      <option value="Central/South America/Antarctica">
        Central/South America/Antarctica
      </option>
      <option value="Europe">Europe</option>
      <option value="Africa/Middle East">Africa/Middle East</option>
      <option value="Asia">Asia</option>
      <option value="Australia/New Zealand/South Pacific">
        Australia/New Zealand/South Pacific
      </option>
    </select>

    <span className="checkItem">
      <InputField
        change={props.change}
        fieldLabel="I agree to the transfer of the personal data I have provided in connection with my registration for this event to all hotels participating in this event, which may include the transfer of my personal data to jurisdictions outside of my home country."
        fieldName="opt_in_marketing"
        fieldType="checkbox"
        icon="envelope"
        userSelect={false}
        line={false}
        title="I agree to the transfer of the personal data I have provided in connection with my registration for this event to all hotels participating in this event, which may include the transfer of my personal data to jurisdictions outside of my home country."
      />
    </span>

    <div className="login__form--buttons">
      {window.location.pathname !== '/register' && <Link to="/login">
        <button type="button" onClick={props.back} className="Email__input--button btnInverse">{i18n.translate('general.back')}</button>
      </Link>}
      <button
        type="submit"
        onClick={props.submit}
        className="Email__input--button"
      >
        {props.loadingAnimRegister ? (
          <span>
            <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
          </span>
        ) : (
          i18n.translate('loginScreen.register')
        )}
      </button>
    </div>
  </div>
);

export default RegisterTrade;

RegisterTrade.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
};

RegisterTrade.defaultProps = {
  defaultVal: '',
};
